export enum VehicleListSortOption {
  BASE = '',
  PRICE_DESC = 'pricingSummary.hourlyPrice,desc',
  PRICE_ASC = 'pricingSummary.hourlyPrice,asc',
}

export enum ExperienceListSortOption {
  BASE = '',
  PRICE_DESC = 'sessions.price.amount,desc',
  PRICE_ASC = 'sessions.price.amount,asc',
}
